import { Component } from 'preact-compat'
import Button from 'preact-material-components/Button'
import { connect } from 'preact-redux'
import { withNamespaces } from 'react-i18next'
import Credential from '../Credential'
import CheckIcon from '../Icons/CheckIcon'
import ErrorIcon from '../Icons/ErrorIcon'
import styles from './OrderSuccess.scss'

const selectOrderSuccessOrFailure = state => state.orderStatus

const mapStateToProps = state => ({
    hasError: selectOrderSuccessOrFailure(state)
})

@connect(
    mapStateToProps,
    {}
)
class OrderSuccess extends Component {
    render() {
        const { onBackToStart, hasError, t } = this.props

        const { error } = hasError

        return (
            <div class={styles.orderSuccess}>
                <div class={styles.successIcon}>{error ? <ErrorIcon /> : <CheckIcon />}</div>
                {error ? (
                    <div class={styles.failureText}>{t('OrderSuccess.bookingfailure')}</div>
                ) : (
                    <div class={styles.successText}>{t('OrderSuccess.bookingcomplete')}</div>
                )}
                <Button class={styles.toStart} onClick={() => onBackToStart()}>
                    {t('OrderSuccess.newsearch')}
                </Button>

                <Credential />
            </div>
        )
    }
}

export default withNamespaces()(OrderSuccess)



// WEBPACK FOOTER //
// ./components/OrderSuccess/OrderSuccess.js